import React from 'react'
import moment from 'moment'
import classnames from 'classnames'

import {BaseDialog, Role} from 'dialogs/BaseDialog'
import Header from 'common/Header'
import Table from 'common/Table'
import {SORT_ORDER} from 'common/Table'
import Footer from 'common/Footer'
import {getMessage as msg} from 'MessageBundle'
import {replaceJsxPlaceholders} from 'common/Replace';

import theme from './../Complaint.scss'
import conf from 'configuration.json'

import editImg from './edit.png';

export default class Status extends BaseDialog {

    constructor(props) {
        super(props);

        this.state = {
            complaints: [],
            tvppRedirectRequired: true,
            additionalTableOpened: false
        }
    }

    getAllowedRoles() {
        return [Role.SALES_PARTNER, Role.VPQ_OPERATOR];
    }

    componentDidMount() {
        super.init(() => {
            this.tableStructure = [
                {
                    attribute: "number", label: msg('status.column.complaintNumber'), width: '190px',
                    bodyStyle: theme.txtRight,
                    render: (row) => {return row.number}
                },
                {
                    attribute: "created", label: msg('status.column.creationTime'), width: '150px',
                    headStyle: theme.columnCreationTime, bodyStyle: classnames(theme.columnCreationTime, theme.txtRight),
                    render: (row) => {return this.dateToString(row.created)}
                },
                {
                    attribute: "reason", label: msg('status.column.complaintReason'), width: '170px',
                    render: (row) => {return <div className={theme.txtOverflow} title={row.reason}>{row.reason}</div>}
                },
                {
                    attribute: "externalReference", label: msg('status.column.externalReference'),
                    fullLabel: msg('status.column.externalReference.full'), width: '120px',
                    headStyle: theme.externalReference, bodyStyle:theme.txtRight,
                    render: (row) => {return row.externalReference}
                },
                {
                    attribute: "state", label: msg('status.column.state'), width: '130px',
                    render: (row) => {return row.state}
                },
                {
                    attribute: "extendComplaint", label: msg('status.column.extendComplaint'), width: '170px',
                    render: (row, index) => {
                        if (row.extendable) {
                            return (
                                <button id={"extendComplaint-btn" + index} onClick={() => this.props.history.push('/extend', {complaintNumber: row.number})}
                                    className={theme.btnEdit} title={msg('status.edit')}>
                                    <img src={editImg} alt={msg('status.edit')}/>
                                </button>
                            );
                        } else {
                            return msg('status.notEditable');
                        }
                    }
                }
            ];

            // Additional table used to show sub - vos complaints.
            this.additionalTableStructure = [
                {
                    attribute: "vo", label: msg('status.column.vo'), width: '80px',
                    bodyStyle: theme.txtRight,
                    render: (row) => {return row.subVo}
                },
                {
                    attribute: "number", label: msg('status.column.complaintNumber'), width: '190px',
                    bodyStyle: theme.txtRight,
                    render: (row) => {return row.number}
                },
                {
                    attribute: "created", label: msg('status.column.creationTime'), width: '150px',
                    headStyle: theme.columnCreationTime, bodyStyle: classnames(theme.columnCreationTime, theme.txtRight),
                    render: (row) => {return this.dateToString(row.created)}
                },
                {
                    attribute: "reason", label: msg('status.column.complaintReason'), width: '170px',
                    render: (row) => {return <div className={theme.txtOverflow} title={row.reason}>{row.reason}</div>}
                },
                {
                    attribute: "externalReference", label: msg('status.column.externalReference'),
                    fullLabel: msg('status.column.externalReference.full'), width: '120px',
                    headStyle: theme.externalReference, bodyStyle:theme.txtRight,
                    render: (row) => {return row.externalReference}
                },
                {
                    attribute: "state", label: msg('status.column.state'), width: '130px',
                    render: (row) => {return row.state}
                }
            ];
            this.request('get', conf.rest.complaintSecureEndpoint).send((result) => {
                this.setState({
                    complaints: result.body.filter(complaint => !complaint.subVo),
                    subVosComplaints: result.body.filter(complaint => complaint.subVo),
                    initialized: true
                });
            })
        });
    }

    dateToString = (dateObj) => {
        let dateMoment = moment(dateObj);
        return dateMoment.format('DD.MM.YYYY') + ' um ' + dateMoment.format('HH:mm');
    };

    getDialog()  {
        return (
            <div>
                <Header value={msg('complaintManagement.header')}/>
                <section>
                    <div>
                        <h2>{msg('status.header') + this.state.vo}</h2>
                        <div className={theme.statusWrap}>
                            <p>{msg('status.hint.1')}</p>
                            <p>
                                {replaceJsxPlaceholders(msg('status.hint.2'), <strong>{msg('status.hint.2.strong')}</strong>)}
                            </p>
                            <h3>{msg('status.table.title')}</h3>
                            <div className={theme.tblWrap + " " + theme.complaintStatusTbl}>
                                <div className={theme.tblWrapInner}>
                                    <Table structure={this.tableStructure} value={this.state.complaints} sortable
                                        defaultSortColumn="created" defaultSortOrder={SORT_ORDER.DESC} />
                                </div>
                            </div>
                            {this.state.additionalTableOpened ?
                                <div>
                                    <h3>{msg('status.additionalTable.title')}</h3>
                                    <p>{msg('status.additionalTable.description')}</p>
                                    <div className={theme.tblWrap + " " + theme.complaintStatusTbl}>
                                        <div className={theme.tblWrapInner}>
                                            <Table structure={this.additionalTableStructure}
                                                value={this.state.subVosComplaints} sortable
                                                defaultSortColumn="created" defaultSortOrder={SORT_ORDER.DESC}/>
                                        </div>
                                    </div>
                                </div>
                                : ""}
                        </div>
                        <div className={theme.btnGroup}>
                            <button id="showSubVos-btn" hidden={!this.state.subVosComplaints} onClick={() => {
                                this.setState({
                                    additionalTableOpened: !this.state.additionalTableOpened
                                })
                            }}>{this.state.additionalTableOpened ? msg('status.hideSubVosBtn') : msg('status.showSubVosBtn')}</button>
                            <button id="newComplaint-btn" onClick={() => {this.props.history.push('/new')}}>{msg('status.newComplaintBtn')}</button>
                            <button id="cancel-btn" className={theme.accent} onClick={this.closeWindow}>{msg('status.closeWindowBtn')}</button>
                        </div>
                    </div>
                </section>
                <Footer />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/dialogs/Status/index.js